import React from "react";
import { useNavigate } from "react-router-dom";
import { Typography, Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";

const TableHeader = ({ title, addUrl = "", addFunc, rightBtn }) => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        display: "flex",
        justifyContent: title ? "space-between" : "end",
        padding: "10px 5px",
      }}
    >
      <Typography style={{ fontWeight: "600" }}>{title}</Typography>
      <div>
        {rightBtn && rightBtn}

        {(addUrl || addFunc) && (
          <Button
            size="small"
            type="primary"
            shape={"circle"}
            icon={<PlusOutlined />}
            onClick={() => {
              addFunc ? addFunc() : navigate(`${addUrl}/new`);
            }}
            style={{ marginLeft: "20px" }}
          />
        )}
      </div>
    </div>
  );
};

export default TableHeader;
